export default __webpack_public_path__ + "static/media/webStudio.78ce774a.jpg";